import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const pageData: Record<string, {
  title: string;
  text: React.ReactNode;
  param: string;
}> = {
  '1': {
    title: 'Privacy Statement',
    param: 'privacy',
    text: <div className="space-y-3 text-sm text-slate-800 leading-relaxed" data-id="element-2599">
        <p className="text-red-600 font-semibold" data-id="element-2600">Privacy Statement</p>
        <p data-id="element-2601">
          By registering with Desert Sage Seminars, you will create an account
          by which we may provide you with quality on-line real estate license
          renewal classes. Your information will be kept confidential and not
          shared with any other party.
        </p>
        <p data-id="element-2602">
          The Arizona Department of Real Estate requires that we confirm your
          information and that you are the person taking the classes.
        </p>
        <p data-id="element-2603">
          Payments you make for our classes are made through a 3rd party
          merchant account secured by our site, and they do not share your
          credit card information with us or any other party.
        </p>
        <p data-id="element-2604">
          Any requests by an outside party for information about you or your
          account will be denied except for any request from the Arizona
          Department of Real Estate, or any other regulatory agency empowered to
          investigate your real estate activity.
        </p>
        <p data-id="element-2605">
          Any questions or concerns about our Privacy Policy should be sent to{' '}
          <a href="mailto:support@desertsageseminars.com" className="text-blue-600 hover:underline" data-id="element-2606">
            support@desertsageseminars.com
          </a>
        </p>
      </div>
  },
  '2': {
    title: 'About Us',
    param: 'about-us',
    text: <div className="text-sm text-slate-800 leading-relaxed" data-id="element-2607">
        <p className="text-red-600 font-semibold mb-2" data-id="element-2608">About Us</p>
        <p data-id="element-2609">Learn about our history and mission.</p>
      </div>
  },
  '3': {
    title: 'Terms of Service',
    param: 'terms',
    text: <div className="text-sm text-slate-800 leading-relaxed" data-id="element-2610">
        <p className="text-red-600 font-semibold mb-2" data-id="element-2611">Terms of Service</p>
        <p data-id="element-2612">Please read these terms carefully.</p>
      </div>
  }
};
export function ViewStaticPage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const page = id && pageData[id] ? pageData[id] : pageData['1'];
  return <div className="space-y-4" data-id="element-2613">
      <div className="flex items-center justify-between" data-id="element-2614">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2615">Static Page</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/static-pages')} data-id="element-2616">
          ← Back to Static Pages
        </Button>
      </div>

      <Card data-id="element-2617">
        <CardContent className="pt-6" data-id="element-2618">
          <table className="text-sm w-full" data-id="element-2619">
            <tbody data-id="element-2620">
              <tr className="border-b border-slate-100" data-id="element-2621">
                <td className="py-2 pr-6 font-medium text-slate-700 w-20 align-top" data-id="element-2622">
                  Title
                </td>
                <td className="py-2 text-slate-900" data-id="element-2623">{page.title}</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2624">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2625">
                  Text
                </td>
                <td className="py-3 max-w-xl" data-id="element-2626">{page.text}</td>
              </tr>
              <tr data-id="element-2627">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2628">
                  Param
                </td>
                <td className="py-2 text-slate-900 font-mono text-xs" data-id="element-2629">
                  {page.param}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6" data-id="element-2630">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/static-pages/edit/${id}`)} data-id="element-2631">
              Edit Page
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}